import { Box, Center, Spinner, Text } from '@chakra-ui/react'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useTranslation } from '../i18n'

export default function ProtectedRoute({ sysAdminOnly = false, eventAdminOnly = false, children }) {
  const { user, isAdmin, isSysAdmin, loading, getEventRole } = useAuth()
  const { t } = useTranslation()
  const location = useLocation()
  const { eventId } = useParams()

  if (loading) {
    return (
      <Center minH="60vh">
        <Spinner size="xl" />
      </Center>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  // eventAdminOnly reads the :eventId the route was matched with, so it is the
  // role in *this* event that counts — a moderator here, an eventadmin next door
  // is still a moderator. The rules and the callable enforce the same thing; this
  // only saves them the trip.
  const deniedAsEventAdmin =
    eventAdminOnly && !isSysAdmin && getEventRole(eventId) !== 'eventadmin'

  if (user && (!isAdmin || (sysAdminOnly && !isSysAdmin) || deniedAsEventAdmin)) {
    return (
      <Box p={8}>
        <Text>{t('common.noPermission')}</Text>
      </Box>
    )
  }

  return children
}
